import { useEffect } from "react";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { DataAwareResponse } from "@/types/types";
import { toast } from "react-toastify";
import errorNotifications from "@/helper/helper";
import { getErrorMessage, logErrorInDev } from "@/helper/errorMessages";

type Props<T> = UseQueryOptions<DataAwareResponse<T>, Error, DataAwareResponse<T>, string[]>;

export function useQueryWithValidation<TData>({ ...restOptions }: Props<TData>) {
  const query = useQuery({
    ...restOptions,
  });

  const validationItems = query?.data?.validation?.items;

  useEffect(() => {
    if (validationItems?.length) {
      errorNotifications(validationItems);
    }
  }, [validationItems?.length]);

  useEffect(() => {
    if (query.isError && query.error) {
      logErrorInDev(query.error, "Query");

      const errorMessage = getErrorMessage(query.error);
      toast.error(errorMessage);
    }
  }, [query.error, query.isError]);

  return query;
}
